/* eslint-disable */
/** Generated by marketing-site/scripts/import-store-shots.mjs — do not hand-edit imports. */
import signal_fire_revealWebp from './signal-fire-reveal.webp';
import signal_fire_whyWebp from './signal-fire-why.webp';
import signal_fire_shared_groundWebp from './signal-fire-shared-ground.webp';
import campfire_boardWebp from './campfire-board.webp';
import prompt_reply_threadWebp from './prompt-reply-thread.webp';
import side_trailWebp from './side-trail.webp';
import mutuals_opt_inWebp from './mutuals-opt-in.webp';
import embers_inboxWebp from './embers-inbox.webp';
import meetup_timesWebp from './meetup-times.webp';
import meetup_planWebp from './meetup-plan.webp';
import meetup_safetyWebp from './meetup-safety.webp';

import signal_fire_revealWebp540 from './signal-fire-reveal-540w.webp';
import signal_fire_whyWebp540 from './signal-fire-why-540w.webp';
import signal_fire_shared_groundWebp540 from './signal-fire-shared-ground-540w.webp';
import campfire_boardWebp540 from './campfire-board-540w.webp';
import prompt_reply_threadWebp540 from './prompt-reply-thread-540w.webp';
import side_trailWebp540 from './side-trail-540w.webp';
import mutuals_opt_inWebp540 from './mutuals-opt-in-540w.webp';
import embers_inboxWebp540 from './embers-inbox-540w.webp';
import meetup_timesWebp540 from './meetup-times-540w.webp';
import meetup_planWebp540 from './meetup-plan-540w.webp';
import meetup_safetyWebp540 from './meetup-safety-540w.webp';

export const SIGNAL_FIRE_REVEAL_SCREENSHOT = {
  webp: [{ src: signal_fire_revealWebp540, width: 540 }, { src: signal_fire_revealWebp, width: 1080 }],
  fallback: [{ src: signal_fire_revealWebp, width: 1080 }],
  intrinsic: { w: 1080, h: 1920 },
  alt: "Kynward Signal Fire — your answer and theirs, revealed together after you both reply",
  crops: { moment: { top: 0.4375, height: 0.396 } },
} as const;

export const SIGNAL_FIRE_WHY_SCREENSHOT = {
  webp: [{ src: signal_fire_whyWebp540, width: 540 }, { src: signal_fire_whyWebp, width: 1080 }],
  fallback: [{ src: signal_fire_whyWebp, width: 1080 }],
  intrinsic: { w: 1080, h: 1920 },
  alt: "Kynward Signal Fire — one introduction a day, with a way in to start talking",
  crops: { moment: { top: 0.234, height: 0.53 } },
} as const;

export const SIGNAL_FIRE_SHARED_GROUND_SCREENSHOT = {
  webp: [{ src: signal_fire_shared_groundWebp540, width: 540 }, { src: signal_fire_shared_groundWebp, width: 1080 }],
  fallback: [{ src: signal_fire_shared_groundWebp, width: 1080 }],
  intrinsic: { w: 1080, h: 1920 },
  alt: "Kynward Signal Fire — the ground you already share, as conversation material",
  crops: { moment: { top: 0.24, height: 0.338 } },
} as const;

export const CAMPFIRE_BOARD_SCREENSHOT = {
  webp: [{ src: campfire_boardWebp540, width: 540 }, { src: campfire_boardWebp, width: 1080 }],
  fallback: [{ src: campfire_boardWebp, width: 1080 }],
  intrinsic: { w: 1080, h: 1920 },
  alt: "Kynward Circle Campfire — tonight’s prompt under the stars",
  crops: { moment: { top: 0.352, height: 0.357 } },
} as const;

export const PROMPT_REPLY_THREAD_SCREENSHOT = {
  webp: [{ src: prompt_reply_threadWebp540, width: 540 }, { src: prompt_reply_threadWebp, width: 1080 }],
  fallback: [{ src: prompt_reply_threadWebp, width: 1080 }],
  intrinsic: { w: 1080, h: 1920 },
  alt: "Kynward Campfire reply thread — follow up on someone’s answer",
  crops: { moment: { top: 0.09, height: 0.49 } },
} as const;

export const SIDE_TRAIL_SCREENSHOT = {
  webp: [{ src: side_trailWebp540, width: 540 }, { src: side_trailWebp, width: 1080 }],
  fallback: [{ src: side_trailWebp, width: 1080 }],
  intrinsic: { w: 1080, h: 1920 },
  alt: "Kynward Side Trail — a lighter side conversation running alongside the Circle",
  crops: { moment: { top: 0.572, height: 0.285 } },
} as const;

export const MUTUALS_OPT_IN_SCREENSHOT = {
  webp: [{ src: mutuals_opt_inWebp540, width: 540 }, { src: mutuals_opt_inWebp, width: 1080 }],
  fallback: [{ src: mutuals_opt_inWebp, width: 1080 }],
  intrinsic: { w: 1080, h: 1920 },
  alt: "Kynward Mutuals opt-in - privately choose who you'd be open to after a Circle",
  crops: { moment: { top: 0.083, height: 0.532 } },
} as const;

export const EMBERS_INBOX_SCREENSHOT = {
  webp: [{ src: embers_inboxWebp540, width: 540 }, { src: embers_inboxWebp, width: 1080 }],
  fallback: [{ src: embers_inboxWebp, width: 1080 }],
  intrinsic: { w: 1080, h: 1920 },
  alt: "Kynward Mutuals inbox - your ongoing connections from past Circles",
  crops: { moment: { top: 0.535, height: 0.175 } },
} as const;

export const MEETUP_TIMES_SCREENSHOT = {
  webp: [{ src: meetup_timesWebp540, width: 540 }, { src: meetup_timesWebp, width: 1080 }],
  fallback: [{ src: meetup_timesWebp, width: 1080 }],
  intrinsic: { w: 1080, h: 1920 },
  alt: "Kynward meetup — times on the table, and the count that keeps one person from committing the group",
  crops: { moment: { top: 0.091, height: 0.409 } },
} as const;

export const MEETUP_PLAN_SCREENSHOT = {
  webp: [{ src: meetup_planWebp540, width: 540 }, { src: meetup_planWebp, width: 1080 }],
  fallback: [{ src: meetup_planWebp, width: 1080 }],
  intrinsic: { w: 1080, h: 1920 },
  alt: "Kynward meetup plan — the agreed time, the place, and how many people are going",
  crops: { moment: { top: 0.078, height: 0.286 } },
} as const;

export const MEETUP_SAFETY_SCREENSHOT = {
  webp: [{ src: meetup_safetyWebp540, width: 540 }, { src: meetup_safetyWebp, width: 1080 }],
  fallback: [{ src: meetup_safetyWebp, width: 1080 }],
  intrinsic: { w: 1080, h: 1920 },
  alt: "Kynward meetup safety check-in — tell us you arrived, and we'll check in afterwards",
  crops: { moment: { top: 0.3646, height: 0.545 } },
} as const;

export const CIRCLE_INSIDE_SCREENSHOTS = [
  CAMPFIRE_BOARD_SCREENSHOT,
  PROMPT_REPLY_THREAD_SCREENSHOT,
  SIDE_TRAIL_SCREENSHOT,
] as const;

export const CIRCLE_WRAP_SCREENSHOTS = [
  MUTUALS_OPT_IN_SCREENSHOT,
  EMBERS_INBOX_SCREENSHOT,
] as const;
